const thirdPartyErrorStatus = {
  INVALID_VOUCHER_TYPE: 'msg_codes_codes_tooltip_codeProductNotFound',
  BATCH_LABEL_IN_USE: 'msg_codes_codes_tooltip_invalidBatchControlLabel',
  BATCH_ALREADY_ACTIVE: 'msg_codes_codes_tooltip_batchAlreadyActive',
  BATCH_ALREADY_CANCELLED: 'msg_codes_codes_tooltip_batchAlreadyCanceled',
  PREEXISTING_ACTIVE_VOUCHERS: 'msg_codes_codes_tooltip_activationAlreadyInProgress',
};

export default thirdPartyErrorStatus;
